<div class="design-step-content">
  <div id="design-area">
    <stage #stage>
      <advent-calendar-overlay></advent-calendar-overlay>
    </stage>
    <additional-info-items
      [additionalInfoItems]="additionalInfoItemsDesignArea">
    </additional-info-items>
  </div>
  <input imageUpload #imageSelect id="image-select"
    type="file" multiple accept="image/*"/>

  <div id="toolboxes">
    <!-- Overlay-Toolboxes -->
    @if (activeToolbox === 'ImageToolbox') {
      <image-toolbox [type]="'overlay'"
        data-iframe-size
      ></image-toolbox>
    }

    @if (activeToolbox === 'TextToolbox') {
      <text-toolbox [type]="'overlay'"
        data-iframe-size
      ></text-toolbox>
    }

    @if (isSmallDevice || isMediumDevice) {
      @if (isStaticToolboxAvailable('LayoutToolbox')) {
        <layout-toolbox
          [visible]="activeToolbox === 'LayoutToolbox'"
          [type]="'overlay'"
          data-iframe-size
          [templateGroups]="templateGroups"
          [templatesSettings]="templatesSettings"
        ></layout-toolbox>
      }
      @if (activeToolbox === 'GalleryToolbox') {
        <gallery-toolbox
          [type]="'overlay'"
          [visible]="'true'"
          data-iframe-size
        ></gallery-toolbox>
      }
      @if (activeToolbox === 'ImageToolbox') {
        <image-toolbox
          [type]="'overlay'"
          [visible]="'true'"
          data-iframe-size
        ></image-toolbox>
      }
      @if (isStaticToolboxAvailable('PreviewToolbox')) {
        <preview-toolbox [type]="'overlay'"
          data-iframe-size
          [visible]="activeToolbox === 'PreviewToolbox'"
        ></preview-toolbox>
      }
    }

    <!-- Large- & Medium-Layout -->
    @if (toolboxes && !isSmallDevice) {
      <div id="toolboxes-large">
        @if (currentProductName) {
          <span class="product-name">
            {{currentProductName}}
          </span>
        }
        @if (currentProductName) {
          <hr class="product-line-break" />
        }
        @if (displayProductChooser &&
          isStaticToolboxAvailable('ProductChooserToolbox')) {
          <div class="toolbox"
            [class.aii-graphics-team-feature]=
            "additionalInfoItemsToolboxes.length > 0"
            >
            <product-chooser-toolbox #productChooserToolbox
              [type]="'static'"
            ></product-chooser-toolbox>
          </div>
        }
        <additional-info-items
          [additionalInfoItems]="additionalInfoItemsToolboxes">
        </additional-info-items>
        @if (isStaticToolboxAvailable('GalleryToolbox')) {
          <button class="toolbox active-animation"
            [class.aii-graphics-team-feature]=
            "additionalInfoItemsToolboxes.length > 0"
            (click)="photosButtonClicked()">
            @if (!isMediumDevice) {
              <mat-icon svgIcon="upload"></mat-icon>
              {{ 'i18n.button.uploadPhotos' | translate }}
            }
            @if (isMediumDevice) {
              <mat-icon svgIcon="photos"></mat-icon>
              {{ 'i18n.button.photos' | translate }}
            }
          </button>
        }
        @if (isStaticToolboxAvailable('LayoutToolbox') &&
          isMediumDevice) {
          <button class="toolbox"
            >
            <toolbox-trigger
              [triggerName]="'Layout'"
              [toolbox]="'LayoutToolbox'"
            ></toolbox-trigger>
          </button>
        }
        @if (showCreateNewTextPlaceholdersButton) {
          <button class="toolbox"
            (click)="createNewTextPlaceholdersButtonClicked()">
            <mat-icon svgIcon="text"></mat-icon>
            @if (!isMediumDevice) {
              {{ 'i18n.button.createNewTextPlaceholders' | translate }}
            }
            @if (isMediumDevice) {
              {{ 'i18n.button.mobile.createNewTextPlaceholders' | translate }}
            }
          </button>
        }
        @if (!isMediumDevice && toolboxTabs.length === 1) {
          <div class="toolbox"
            >
            @if (toolboxTabs[0] === 'GalleryToolbox') {
              <gallery-toolbox [type]="'static'" [displayTitle]="true"
                               [visible]="'true'"
              ></gallery-toolbox>
            }
            @if (toolboxTabs[0] === 'LayoutToolbox') {
              <layout-toolbox [displayTitle]="true"
                [type]="'static'"
                [visible]="'true'"
                [templateGroups]="templateGroups"
                [templatesSettings]="templatesSettings"
              ></layout-toolbox>
            }
          </div>
        }
        @if (!isMediumDevice && toolboxTabs.length > 1) {
          <div class="tabbed-toolbox"
            >
            <nav>
              <span [class.active]="toolboxTabs[selectedToolboxTabsIndex] === 'LayoutToolbox'"
                (click)="updateSelectedTabbedToolboxIndex('LayoutToolbox')">
                <mat-icon svgIcon="layouts"></mat-icon>
                {{ 'i18n.toolbox.layout.title' | translate }}
              </span>
              <span [class.active]="toolboxTabs[selectedToolboxTabsIndex] === 'GalleryToolbox'"
                (click)="updateSelectedTabbedToolboxIndex('GalleryToolbox')">
                <mat-icon svgIcon="photos"></mat-icon>
                {{ 'i18n.toolbox.gallery.title' | translate }}
              </span>
              <span class="spacer">
              </span>
            </nav>
            <div>
              @for (tab of toolboxTabs; track tab) {
                <div class="toolbox" [class.active]="toolboxTabs[selectedToolboxTabsIndex] === tab">
                  @if (tab === 'GalleryToolbox') {
                    <gallery-toolbox [type]="'static'"
                                     [displayTitle]="false"
                                     [visible]="'true'"
                    ></gallery-toolbox>
                  }
                  @if (tab === 'LayoutToolbox') {
                    <layout-toolbox
                      [displayTitle]="false"
                      [type]="'static'"
                      [visible]="'true'"
                      [templateGroups]="templateGroups"
                      [templatesSettings]="templatesSettings"
                    ></layout-toolbox>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (isStaticToolboxAvailable('PreviewToolbox') &&
          isMediumDevice) {
          <button class="toolbox"
            >
            <toolbox-trigger
              [triggerName]="'Preview'"
              [toolbox]="'PreviewToolbox'"
            ></toolbox-trigger>
          </button>
        }
        @if (!isMediumDevice &&
          isStaticToolboxAvailable('PreviewToolbox')) {
          <div class="toolbox"
            >
            <preview-toolbox [type]="'static'"
                             [visible]="'true'"
            ></preview-toolbox>
          </div>
        }
        @if (!displayProductChooser) {
          <div class="price-box">
            <price-display [price]="priceCalculationService.singleProductTotal"
              [showPriceLabel]="true"
              [name]="priceName"
              [quantity]="productConfig.quantity">
            </price-display>
          </div>
        }
      </div>
    }

    <!-- Small-Layout -->
    @if (toolboxes && isSmallDevice) {
      <div id="toolboxes-small">
        @if (currentProductName) {
          <span class="product-name">
            {{currentProductName}}
          </span>
        }
        <div id="toolbox-triggers" #toolboxTriggers>
          @if (displayProductChooser &&
            isStaticToolboxAvailable('ProductChooserToolbox')) {
            <span class="toolbox"
              >
              <product-chooser-toolbox #productChooserToolbox
                [type]="'static'"
                [style.display]="'none'"
                [visible]="activeToolbox === 'ProductChooserToolbox'"
              ></product-chooser-toolbox>
              @if (displayProductChooser &&
                isStaticToolboxAvailable('ProductChooserToolbox')) {
                <toolbox-trigger
                  [triggerName]="'ProductChooser'"
                  (click)="productChooserToolbox.openProductChooserDirectly($event)"
                ></toolbox-trigger>
              }
            </span>
          }
          @if (isStaticToolboxAvailable('GalleryToolbox')) {
            <button class="toolbox active-animation"
              (click)="photosButtonClicked()">
              <mat-icon svgIcon="photos"></mat-icon>
              {{ 'i18n.button.photos' | translate }}
            </button>
          }
          @if (isStaticToolboxAvailable('LayoutToolbox')) {
            <span class="toolbox"
              >
              <toolbox-trigger
                [triggerName]="'Layout'"
                [toolbox]="'LayoutToolbox'"
              ></toolbox-trigger>
            </span>
          }
          @if (isStaticToolboxAvailable('PreviewToolbox')) {
            <span class="toolbox"
              >
              <toolbox-trigger
                [triggerName]="'Preview'"
                [toolbox]="'PreviewToolbox'"
              ></toolbox-trigger>
            </span>
          }
          @if (showCreateNewTextPlaceholdersButton) {
            <button class="toolbox"
              (click)="createNewTextPlaceholdersButtonClicked()">
              <mat-icon svgIcon="text"></mat-icon>
              {{ 'i18n.button.mobile.createNewTextPlaceholders' | translate }}
            </button>
          }
        </div>
        <additional-info-items
          [additionalInfoItems]="additionalInfoItemsToolboxes">
        </additional-info-items>
        <div class="price-box"
          [class.aii-graphics-team-feature]=
          "additionalInfoItemsToolboxes.length > 0">
          <price-display [price]="priceCalculationService.singleProductTotal"
            [showPriceLabel]="true"
            [name]="priceName"
            [quantity]="productConfig.quantity">
          </price-display>
        </div>
      </div>
    }

    <progress-buttons [progressChangeable]="progressChangeable">
    </progress-buttons>
  </div>
</div>
